// extracted by mini-css-extract-plugin
export default {"contactInfo":"styles_contactInfo__0rixi","heading":"styles_heading__aIqMJ","details":"styles_details__xKYK5","container":"styles_container__M+d0p"};